export function topsideBanner(element, place) {
    var d = new Date(),
        id = 'apd' + d.getTime() + Math.floor(Math.random());
    let div = document.createElement('div');
    div.id = id;
  
    if (element.children().length > 0) {
      element.empty();
    }
  
    element.append(div);
    let storage;
    let target;
    let removeSizes = [];
    let blockFormats = [];
    let currentEdition = document.querySelector('body').dataset.edtn;
    if (window.stroerData == undefined) {
      console.log('No stroer data');
      return;
    }
    window.stroerData.targetingAttrs['m1_banner_name'] = "mobile_gallery"; 
    if (currentEdition == 'de') {
      window.stroerData.targetingAttrs['m1_edition'] = "de";
    } else {
      window.stroerData.targetingAttrs['m1_edition'] = "ev_de";
    }
  
    SDG.Publisher.setZone(window.stroerData.zone);
  
    if (place == 'sidebar') {
      SDG.Publisher.unregisterSlot('rectangle', true);
      storage = 'rectangle';
      removeSizes = [[728, 180], [770, 250], [800, 250], [970, 250]];
    } else {
      if (device && device.type === 'mobile') {
  
        if (window.stroerData.topmobile == 1) {
          SDG.Publisher.unregisterSlot('topmobile', true);
        }

        storage = 'topmobile';
        removeSizes = [
          [320, 75],
          [320, 100],
          [320, 150],
          [300, 250],
          [468, 60],
          [728, 90],
          [300, 253],
          [320, 253],
          [320, 250],
        ];
        blockFormats.push('mobilehalfpagead', 'mobilePresenterRectangle');
        window.stroerData.topmobile = 1;
  
      } else if (device && device.type === 'desktop') {
        SDG.Publisher.unregisterSlot('banner2', true);
        storage = 'banner2';
        removeSizes = [[728, 181]];
        blockFormats = ['doubleleaderboard'];
      }
    }
    if (storage) {
      target = SDG.Publisher.registerSlot(storage, div.id);
      if (removeSizes.length !== 0) {
        target.removeSizes(removeSizes);
      }
      if (blockFormats.length !== 0) {
        target.blockFormats(blockFormats);
      }
  
      target.setTargeting(window.stroerData.targetingAttrs).load();
      SDG.Publisher.finalizeSlots();
    }
  
}